<template>
  <div v-if="!isPrint">
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    장비정보-->
    <!--  [신규] SHM 시스템 URL 생성 및 메뉴 구성 | #86ep5bb9n 요청에 의해 메뉴 숨김 -->
    <!--    <table-equipment-->
    <!--      class="mt-5"-->
    <!--      :list="form.equipmentList"-->
    <!--      @updateList="updateList"-->
    <!--      :isPrint="isPrint"-->
    <!--      :isReadonly="board.readonly"-->
    <!--    ></table-equipment>-->

    <!--    점검대상-->
    <!--    <vs-row class="mt-6">-->
    <!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
    <!--        <h5>-->
    <!--          <i class="dot"></i> 점검대상-->
    <!--        </h5>-->
    <!--      </vs-col>-->
    <!--    </vs-row>-->

    <!--    <div class="gap-x-6 gap-y-4 mt-4">-->
    <!--      <span v-if="isPrint"> {{form.inspectionTitle}} </span>-->
    <!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
    <!--        <vs-checkbox-->
    <!--          class="mr-1 mb-2"-->
    <!--          :readonly="board.readonly">-->
    <!--          {{form.inspectionTitle}}-->
    <!--        </vs-checkbox>-->
    <!--      </div>-->
    <!--    </div>-->

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />

    <!-- 결재란 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i>{{ $t('결재란') }}</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
  <print v-else :board="board" :form="form"/>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import Print from "./Print.vue";

export default {
  components: {
    Print,
    NameWithSignatureRow,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        this.form.inspectionTitle = this.inspectionTitle;
        if (
          !this.form ||
          !this.form.inspectList ||
          this.form.inspectList.length === 0
        ) {
          this.form.inspectList = this.inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "근골격계질환",
      form: {
        inspectionTitle: "근골격계질환",
        stdInfo: {},
        photoList: [],

        inputD_1: {},
        inputD_2: "",
        inputD_3: {},
        inputD_4: "",
        inputD_5: {},
        inputD_6: "",
        inputD_7: {},
        inputD_8: "",

        fileList: [],
        equipmentList: [],
        inspectList: [],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },
      },
    };
  },
  computed: {
    inspectTable() {
      return [
        {
          id: 1,
          label:
            "근골격계질환이 발생할 수 있는 위험요인과 작업내용을 파악하고 있다. ",
          is_checked: "",
        },
        {
          id: 2,
          label:
            "근골격계질환 유해요인조사를 적정하게 실시하고 그 결과를 알리고 있다. ",
          is_checked: "",
        },
        {
          id: 3,
          label:
            "근골격계질환 발생 우려가 있는 경우 인간공학적 설계, 인력작업 보조설비 및 편의설비를 설치하고 있다.",
          is_checked: "",
        },
        {
          id: 4,
          label:
            "부담작업 종사자 교육(유해요인, 징후와 증상, 대처 요령, 올바른 작업자세, 작업도구, 작업시설의 올바른 사용법)을 실시하고 있다.",
          is_checked: "",
        },
        {
          id: 5,
          label:
            "취급 물품의 중량, 취급빈도, 운반거리, 운반 속도 등 작업조건에 따라 작업시간 및 휴식시간 등을 적정하게 배분하고 있다. ",
          is_checked: "",
        },
        {
          id: 6,
          label:
            "중량물의 중량과 무게중심을 표시하고 손잡이를 붙이거나 갈고리, 진공빨판 등을 활용하고 있다. ",
          is_checked: "",
        },
        {
          id: 7,
          label:
            "중량물 취급자에게 올바른 들기 자세에 대한 교육을 실시하고 있다. ",
          is_checked: "",
        },
        {
          id: 8,
          label:
            "서서 일하는 근로자 또는 VDT 작업자에게 적절한 작업대 등의 작업환경을 제공하고 있다. ",
          is_checked: "",
        },
        {
          id: 9,
          label:
            "관리대상 유해물질 등을 담은 용기에 경고표지가 적절히 부착되어 있다.",
          is_checked: "",
        },
        {
          id: 10,
          label: "근골격계 질환 예방을 위한 프로그램을 운영하고 있다.",
          is_checked: "",
        },
        {
          id: 11,
          label: "근로자가 편히 쉴 수 있는 휴게공간과 휴식시간을 부여한다.",
          is_checked: "",
        },
      ];
    },
  },
  methods: {
    updateList(list) {
      this.form.equipmentList = list;
    },
    updateListCheck(indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
